import { render, staticRenderFns } from "./cashback-order-provider.vue?vue&type=template&id=25a7a18a&"
import script from "./cashback-order-provider.vue?vue&type=script&lang=js&"
export * from "./cashback-order-provider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports